import { Component, OnInit } from '@angular/core';
import {
    HubConnectionBuilder,
    LogLevel,
    HubConnection,
} from '@microsoft/signalr';
import { CheckNetworkService } from 'local-db/services/check-network.service';

@Component({
    selector: 'pcg-push-notification',
    templateUrl: './push-notification.component.html',
    styleUrls: ['./push-notification.component.scss'],
    standalone: false,
})
export class PushNotificationComponent implements OnInit {
    private hubConnection: HubConnection | undefined;
    showNotification = false;
    isOnline: boolean;

    constructor() {}

    /** Reload the page */
    hardReload() {
        window.location.reload();
        return false;
    }

    ngOnInit() {
        this.isOnline = CheckNetworkService.checkNetworkStatus();
        // WebSockets
        if (this.isOnline) {
            this.hubConnection = new HubConnectionBuilder()
                .configureLogging(LogLevel.Debug)
                .withUrl('/install-notify')
                .build();
            this.hubConnection
                .start()
                .catch((err) => console.error(err.toString()));

            this.hubConnection.on('install', () => {
                this.showNotification = true;
            });

            const setTimerEvent = () => {
                if (this.showNotification === false) {
                    // Time to wait before attempting reconnect.
                    // Randomized to prevent denial of servicing ourselves.
                    const timeToWait =
                        (Math.trunc(Math.random() * 10000) % 6) + 1;

                    // Continuously try to reconnect
                    // to server on failure
                    setTimeout(() => {
                        this.hubConnection.start().catch(setTimerEvent);
                    }, timeToWait);
                }
            };

            this.hubConnection.onclose(setTimerEvent);
        }
    }
}
